<div class="tech-section">
  <!-- topic -->
  <div class="box-container">
    <div class="u-text-center">
      <h2
        class="new-headtext _heading u-mw-unset  font-size-big"
        [innerHTML]="'WORK_WITH_US.TECH_SECTION.HEADING' | translate"
      ></h2>
    </div>

    <div class="tech-section__readmore u-text-center" [innerHTML]="'WORK_WITH_US.TECH_SECTION.DETAIL' | translate">
    </div>

    <div class="tech-section__box">
      <div class="tech-section__logo-container u-box-center">
        <ng-container *ngFor="let item of logoList">
          <div class="tech-section__logo">
            <picture class="u-box-center">
              <source srcset="{{ item.imageWebP }}" type="image/webp" />
              <source srcset="{{ item.image }}" type="image/{{ item.imageType }}" />
              <img
                class="tech-section__logo--{{ item.imageClassName }}"
                src="{{ item.image }}"
                alt="{{ item.imageAlt }}"
                loading="lazy"
              />
            </picture>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
